import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from "./AuthProvider";

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const token = localStorage.getItem('jwtToken');

    if (!isAuthenticated && !token) {
        return <Navigate to="/" />;
    }

    return children;
};

export default ProtectedRoute